export enum GraphicTitle {
  BESTSELLERS = 'BESTSELLERS',
  BAPTISM_AND_COMMUNION = 'BAPTISM_AND_COMMUNION',
  CHILDREN = 'CHILDREN',
  ANIMALS = 'ANIMALS',
  NATURE = 'NATURE',
  CONFESSIONS = 'CONFESSIONS',
  SYMBOLS = 'SYMBOLS',
  TRAVELS = 'TRAVELS',
  ZODIACS = 'ZODIACS',
  HUMANS = 'HUMANS',
  HALLOWEEN = 'HALLOWEEN',
  SPORT = 'SPORT',
  HOLIDAYS = 'HOLIDAYS',
  VALENTINES = 'VALENTINES',
  MAGIC = 'MAGIC',
}

export const graphics = [
  {
    mainTitle: GraphicTitle.BESTSELLERS,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '1_Aniolek.webp',
        file_to_send: '1_Aniolek.png',
      },
      {
        file: '51_Rece.webp',
        file_to_send: '51_Rece.png',
      },
      {
        file: '24_Kon.webp',
        file_to_send: '24_Kon.png',
      },
      {
        file: '3_Stopki.webp',
        file_to_send: '3_Stopki.png',
      },
      {
        file: '4_Motylek.webp',
        file_to_send: '4_Motylek.png',
      },
      {
        file: 'serca_1.webp',
        file_to_send: 'serca_1.png',
      },
      {
        file: '27_Kroliczek.webp',
        file_to_send: '27_Kroliczek.png',
      },
      {
        file: '10_Stokrotki.webp',
        file_to_send: '10_Stokrotki.png',
      },
      {
        file: '23_lapa.webp',
        file_to_send: '23_lapa.png',
      },
      {
        file: '65_Self_Love.webp',
        file_to_send: '65_Self_Love.png',
      },
      {
        file: '31_KOMPAS.webp',
        file_to_send: '31_KOMPAS.png',
      },
      {
        file: '9_Kwiat_lotosu.webp',
        file_to_send: '9_Kwiat_lotosu.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.BAPTISM_AND_COMMUNION,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '1_Aniolek.webp',
        file_to_send: '1_Aniolek.png',
      },
      {
        file: '3_Stopki.webp',
        file_to_send: '3_Stopki.png',
      },
      {
        file: '67_IHS.webp',
        file_to_send: '67_IHS.png',
      },
      {
        file: '68_IHS-2.webp',
        file_to_send: '68_IHS-2.png',
      },
      {
        file: '69_Komunia.webp',
        file_to_send: '69_Komunia.png',
      },
      {
        file: '70_Hostia.webp',
        file_to_send: '70_Hostia.png',
      },
      {
        file: '71_Golabek.webp',
        file_to_send: '71_Golabek.png',
      },
      {
        file: '72_Rybka.webp',
        file_to_send: '72_Rybka.png',
      },
      {
        file: '73_Krzyzyk.webp',
        file_to_send: '73_Krzyzyk.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.CHILDREN,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '1_Aniolek.webp',
        file_to_send: '1_Aniolek.png',
      },
      {
        file: '2_Smoczek.webp',
        file_to_send: '2_Smoczek.png',
      },
      {
        file: '3_Stopki.webp',
        file_to_send: '3_Stopki.png',
      },
      {
        file: '5_misiu.webp',
        file_to_send: '5_misiu.png',
      },
      {
        file: 'Kotek_1.webp',
        file_to_send: 'Kotek_1.png',
      },
      {
        file: '27_Kroliczek.webp',
        file_to_send: '27_Kroliczek.png',
      },
      {
        file: '48_Baletnica.webp',
        file_to_send: '48_Baletnica.png',
      },
      {
        file: '6_Konik_na_biegunach.webp',
        file_to_send: '6_Konik_na_biegunach.png',
      },
      {
        file: '23_lapa.webp',
        file_to_send: '23_lapa.png',
      },
      {
        file: 'balony_1.webp',
        file_to_send: 'balony_1.png',
      },
      {
        file: '26_Zwierzaki_2.webp',
        file_to_send: '26_Zwierzaki_2.png',
      },
      {
        file: '24_Kon.webp',
        file_to_send: '24_Kon.png',
      },
      {
        file: '28_Kot.webp',
        file_to_send: '28_Kot.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.ANIMALS,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '24_Kon.webp',
        file_to_send: '24_Kon.png',
      },
      {
        file: '27_Kroliczek.webp',
        file_to_send: '27_Kroliczek.png',
      },
      {
        file: '28_Kot.webp',
        file_to_send: '28_Kot.png',
      },
      {
        file: '26_Zwierzaki_2.webp',
        file_to_send: '26_Zwierzaki_2.png',
      },
      {
        file: '25_Zwierzaki 1.webp',
        file_to_send: '25_Zwierzaki 1.png',
      },
      {
        file: '22_Golab.webp',
        file_to_send: '22_Golab.png',
      },
      {
        file: '5_misiu.webp',
        file_to_send: '5_misiu.png',
      },
      {
        file: 'linearny_kon-3.webp',
        file_to_send: 'linearny_kon-3.png',
      },
      {
        file: 'Krolik.webp',
        file_to_send: 'Krolik.png',
      },
      {
        file: 'linearny_kon1.webp',
        file_to_send: 'linearny_kon1.png',
      },
      {
        file: 'wielblad.webp',
        file_to_send: 'wielblad.png',
      },
      {
        file: 'Renifer_2.webp',
        file_to_send: 'Renifer_2.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.NATURE,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '10_Stokrotki.webp',
        file_to_send: '10_Stokrotki.png',
      },
      {
        file: 'koniczynka1.webp',
        file_to_send: 'koniczynka1.png',
      },
      {
        file: '9_Kwiat_lotosu.webp',
        file_to_send: '9_Kwiat_lotosu.png',
      },
      {
        file: 'gory.webp',
        file_to_send: 'gory.png',
      },
      {
        file: '62_Rozyczka.webp',
        file_to_send: '62_Rozyczka.png',
      },
      {
        file: '13_Kaktus.webp',
        file_to_send: '13_Kaktus.png',
      },
      {
        file: 'truskawka.webp',
        file_to_send: 'truskawka.png',
      },
      {
        file: '12_lisc_monstery.webp',
        file_to_send: '12_lisc_monstery.png',
      },
      {
        file: 'muszla.webp',
        file_to_send: 'muszla.png',
      },
      {
        file: 'Kwiat_1.webp',
        file_to_send: 'Kwiat_1.png',
      },
      {
        file: 'Tulipan_1.webp',
        file_to_send: 'Tulipan_1.png',
      },
      {
        file: '11_Paproc.webp',
        file_to_send: '11_Paproc.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.CONFESSIONS,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '55_I love you.webp',
        file_to_send: '55_I love you.png',
      },
      {
        file: 'serca_1.webp',
        file_to_send: 'serca_1.png',
      },
      {
        file: 'infinity_Love.webp',
        file_to_send: 'infinity_Love.png',
      },
      {
        file: '56_Puls.webp',
        file_to_send: '56_Puls.png',
      },
      {
        file: 'Serce_love.webp',
        file_to_send: 'Serce_love.png',
      },
      {
        file: 'kocham Cie.webp',
        file_to_send: 'kocham Cie.png',
      },
      {
        file: 'SelfLove_2.webp',
        file_to_send: 'SelfLove_2.png',
      },
      {
        file: 'Forever_Friends_1.webp',
        file_to_send: 'Forever_Friends_1.png',
      },
      {
        file: '60_Forever.webp',
        file_to_send: '60_Forever.png',
      },
      {
        file: 'Kupidynek_zwykly.webp',
        file_to_send: 'Kupidynek_zwykly.png',
      },
      {
        file: '62_Rozyczka.webp',
        file_to_send: '62_Rozyczka.png',
      },
      {
        file: 'bukiet_2.webp',
        file_to_send: 'bukiet_2.png',
      },
      {
        file: 'Serce_Tarot.webp',
        file_to_send: 'Serce_Tarot.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.SYMBOLS,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '51_Rece.webp',
        file_to_send: '51_Rece.png',
      },
      {
        file: 'serca_1.webp',
        file_to_send: 'serca_1.png',
      },
      {
        file: 'rece serce.webp',
        file_to_send: 'rece serce.png',
      },
      {
        file: '31_KOMPAS.webp',
        file_to_send: '31_KOMPAS.png',
      },
      {
        file: '22_Golab.webp',
        file_to_send: '22_Golab.png',
      },
      {
        file: 'koniczynka2.webp',
        file_to_send: 'koniczynka2.png',
      },
      {
        file: 'puls_2.webp',
        file_to_send: 'puls_2.png',
      },
      {
        file: '53_Slonce.webp',
        file_to_send: '53_Slonce.png',
      },
      {
        file: 'Czaszka_meksykanska.webp',
        file_to_send: 'Czaszka_meksykanska.png',
      },
      {
        file: 'Dynia_2_czarna.webp',
        file_to_send: 'Dynia_2_czarna.png',
      },
      {
        file: '57_Kieliszki.webp',
        file_to_send: '57_Kieliszki.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.TRAVELS,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '32_Statek.webp',
        file_to_send: '32_Statek.png',
      },
      {
        file: 'samolot_serce_2.webp',
        file_to_send: 'samolot_serce_2.png',
      },
      {
        file: 'muszla.webp',
        file_to_send: 'muszla.png',
      },
      {
        file: '31_KOMPAS.webp',
        file_to_send: '31_KOMPAS.png',
      },
      {
        file: '33_Samolot.webp',
        file_to_send: '33_Samolot.png',
      },
      {
        file: 'gory.webp',
        file_to_send: 'gory.png',
      },
      {
        file: '35_Syrenka_2.webp',
        file_to_send: '35_Syrenka_2.png',
      },
      {
        file: 'smok wawelski.webp',
        file_to_send: 'smok wawelski.png',
      },
      {
        file: '34_Koziolek.webp',
        file_to_send: '34_Koziolek.png',
      },
      {
        file: 'Czaszka_meksykanska.webp',
        file_to_send: 'Czaszka_meksykanska.png',
      },
      {
        file: 'wielblad.webp',
        file_to_send: 'wielblad.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.ZODIACS,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '36_Wodnik.webp',
        file_to_send: '36_Wodnik.png',
      },
      {
        file: '37_Ryby.webp',
        file_to_send: '37_Ryby.png',
      },
      {
        file: '38_Baran.webp',
        file_to_send: '38_Baran.png',
      },
      {
        file: '39_Byk.webp',
        file_to_send: '39_Byk.png',
      },
      {
        file: '40_Bliznieta.webp',
        file_to_send: '40_Bliznieta.png',
      },
      {
        file: '41_Rak.webp',
        file_to_send: '41_Rak.png',
      },
      {
        file: '42_Lew.webp',
        file_to_send: '42_Lew.png',
      },
      {
        file: '43_Panna.webp',
        file_to_send: '43_Panna.png',
      },
      {
        file: '44_Waga.webp',
        file_to_send: '44_Waga.png',
      },
      {
        file: '45_Skorpion.webp',
        file_to_send: '45_Skorpion.png',
      },
      {
        file: '46_Strzelec.webp',
        file_to_send: '46_Strzelec.png',
      },
      {
        file: '47_Koziorozec.webp',
        file_to_send: '47_Koziorozec.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.HUMANS,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: '49_Kobieta.webp',
        file_to_send: '49_Kobieta.png',
      },
      {
        file: '48_Baletnica.webp',
        file_to_send: '48_Baletnica.png',
      },
      {
        file: 'linearna_twarz.webp',
        file_to_send: 'linearna_twarz.png',
      },
      {
        file: '50_Usta.webp',
        file_to_send: '50_Usta.png',
      },
      {
        file: '52_Pocaunek.webp',
        file_to_send: '52_Pocaunek.png',
      },
      {
        file: 'Usta_1.webp',
        file_to_send: 'Usta_1.png',
      },
      {
        file: '51_Rece.webp',
        file_to_send: '51_Rece.png',
      },
      {
        file: 'rece serce.webp',
        file_to_send: 'rece serce.png',
      },
      {
        file: '54_Szpilka.webp',
        file_to_send: '54_Szpilka.png',
      },
      {
        file: '65_Self_Love.webp',
        file_to_send: '65_Self_Love.png',
      },
      {
        file: '20_0_Rh+.webp',
        file_to_send: '20_0_Rh+.png',
      },
      {
        file: '15_A_Rh-.webp',
        file_to_send: '15_A_Rh-.png',
      },
      {
        file: '16_A_Rh+.webp',
        file_to_send: '16_A_Rh+.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.HALLOWEEN,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: 'buu.webp',
        file_to_send: 'buu.png',
      },
      {
        file: 'Czaszka_meksykanska.webp',
        file_to_send: 'Czaszka_meksykanska.png',
      },
      {
        file: 'Duszek_1.webp',
        file_to_send: 'Duszek_1.png',
      },
      {
        file: 'Dynia_2_czarna.webp',
        file_to_send: 'Dynia_2_czarna.png',
      },
      {
        file: 'Kot_2_czarny.webp',
        file_to_send: 'Kot_2_czarny.png',
      },
      {
        file: 'ksiezyc_6.webp',
        file_to_send: 'ksiezyc_6.png',
      },
      {
        file: 'Wiedzma.webp',
        file_to_send: 'Wiedzma.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.SPORT,
    path: '/images/product/drawer/graph/',
    titles: [
      {
        file: 'Pilka_czarna.webp',
        file_to_send: 'Pilka_czarna.png',
      },
      {
        file: 'Korki.webp',
        file_to_send: 'Korki.png',
      },
      {
        file: 'Polska_Gola.webp',
        file_to_send: 'Polska_Gola.png',
      },
      {
        file: 'Pilka.webp',
        file_to_send: 'Pilka.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.HOLIDAYS,
    path: '/images/product/drawer/graph/',
    titles: [
      { file: 'Renifer.webp', file_to_send: 'Renifer.png' },
      { file: 'Bells.webp', file_to_send: 'Bells.png' },
      { file: 'Santa.webp', file_to_send: 'Santa.png' },
      {
        file: 'Ciasteczko.webp',
        file_to_send: 'Ciasteczko.png',
      },
      { file: 'Merry-X.webp', file_to_send: 'Merry-X.png' },
      {
        file: 'Sniezynka.webp',
        file_to_send: 'Sniezynka.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.VALENTINES,
    path: '/images/product/drawer/graph/valetines/',
    titles: [
      {
        file: 'i-love-you.webp',
        file_to_send: 'i-love-you.png',
      },
      {
        file: 'kupidynek.webp',
        file_to_send: 'kupidynek.png',
      },
      { file: 'serca.webp', file_to_send: 'serca.png' },
      {
        file: 'i-love-you-2.webp',
        file_to_send: 'i-love-you-2.png',
      },
      {
        file: 'kocham-cie.webp',
        file_to_send: 'kocham-cie.png',
      },
      { file: 'forever.webp', file_to_send: 'forever.png' },
      {
        file: 'self-love.webp',
        file_to_send: 'self-love.png',
      },
      {
        file: 'serce-love.webp',
        file_to_send: 'serce-love.png',
      },
      { file: 'roza.webp', file_to_send: 'roza.png' },
      {
        file: 'skrzydlate-serce.webp',
        file_to_send: 'skrzydlate-serce.png',
      },
      {
        file: 'rece-serce.webp',
        file_to_send: 'rece-serce.png',
      },
    ],
  },
  {
    mainTitle: GraphicTitle.MAGIC,
    path: '/images/product/drawer/graph/magic/',
    titles: [
      { file_to_send: 'Wiedzma.png', file: 'Wiedzma.webp' },
      {
        file_to_send: 'Kot_2_czarny.png',
        file: 'Kot_2_czarny.webp',
      },
      {
        file_to_send: 'ksiezyc_6.png',
        file: 'ksiezyc_6.webp',
      },
      {
        file_to_send: 'oko_horusa.png',
        file: 'oko_horusa.webp',
      },
      {
        file_to_send: 'jednorozec.png',
        file: 'jednorozec.webp',
      },
      { file_to_send: 'Duszek_1.png', file: 'Duszek_1.webp' },
      {
        file_to_send: 'Dynia_2_czarna.png',
        file: 'Dynia_2_czarna.webp',
      },
    ],
  },
]

export const FONTS = [
  {
    label: '/images/product/drawer/fonts/avant_garde_1l.png',
    value: 'Avant Garde 1L',
  },
  {
    label: '/images/product/drawer/fonts/baby_script_42.png',
    value: 'Baby Script 42',
  },
  {
    label: '/images/product/drawer/fonts/parisienne.png',
    value: 'Parisienne',
  },
  {
    label: '/images/product/drawer/fonts/roman_2l.png',
    value: 'Roman 2L',
  },
  {
    label: '/images/product/drawer/fonts/script_412_1l.png',
    value: 'Script 412 1L',
  },
  {
    label: '/images/product/drawer/fonts/scriptrund_1l.png',
    value: 'ScriptRund 1L',
  },
  {
    label: '/images/product/drawer/fonts/vanessa_56_2l.png',
    value: 'Vanessa 56 2l',
  },
]

export const SPECIAL_CHARACTERS = ['∞', '♡']
